// src/pages/AnnouncementsPage.js
import React, { useState, useEffect } from 'react';
import { getAuth } from 'firebase/auth';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import Announcements from '../Components/Announcements';
import logger from '../utils/logger';

const AnnouncementsPage = () => {
  const [familyBoardId, setFamilyBoardId] = useState(null);
  const [loading, setLoading] = useState(true);
  const auth = getAuth();
  const db = getFirestore();

  useEffect(() => {
    const fetchFamilyBoardId = async () => {
      if (!auth.currentUser) return;
      
      try {
        const userDoc = await getDoc(doc(db, 'users', auth.currentUser.uid));
        if (userDoc.exists()) {
          const userData = userDoc.data();
          setFamilyBoardId(userData.familyCode || 'default');
        }
      } catch (error) {
        logger.error('Error fetching family board ID:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchFamilyBoardId();
  }, [auth.currentUser, db]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!familyBoardId) {
    return <div>Please set up your family code in your profile.</div>;
  }

  return (
    <div className="announcements-page">
      <Announcements familyBoardId={familyBoardId} />
    </div>
  );
};

export default AnnouncementsPage;